import { mdyRange, type RequestStatus, type RequestType } from "@scheduler/shared";

export const TYPE_LABEL: Record<RequestType, string> = {
  PTO: "PTO",
  NTD: "No-travel",
  FIELD: "Field work",
};

export const TYPE_HINT: Record<RequestType, string> = {
  PTO: "Paid time off. Runs the balance math.",
  NTD: "Working, but not available to deploy.",
  FIELD: "A deployment. One or more people.",
};

export const STATUS_LABEL: Record<RequestStatus, string> = {
  PENDING: "Pending",
  APPROVED: "Approved",
  DENIED: "Denied",
  CANCELLED: "Cancelled",
};

/** Hours, one decimal place. */
export const hours = (n: number) => (Math.round(n * 10) / 10).toFixed(1);

/** "11/23/2026 – 11/25/2026": how a request's dates read everywhere, since a request is named by them (PR 9). */
export const dateRange = (start: string, end: string) => mdyRange(start, end);

const CAPACITY: Record<string, string> = {
  SUPERVISOR: "as supervisor",
  HR: "as HR",
  AUTO: "automatically",
  CREATOR: "who created it",
  SUBJECT: "",
  SUPERSEDED: "replaced by a newer request",
};

export const capacity = (code: string | null) => (code ? CAPACITY[code] ?? code.toLowerCase() : "");
